import { FormEvent, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { MyFooter } from '../landingpage/MyFooter';
import MenuComponent from '../component/MenueComponent';
import { IKategorie } from '../util/types';

export type IEreignis = {
  name: string,
}

export function Anmeldung() {

  type IFormError = {
    anrede: string,
    name: string,
    email: string,
    geburtsjahr: string,
    verein: string,
    startkategorie: string,
    check: string,
  }

  type IFormData = {
    anrede: string,
    name: string,
    email: string,
    geburtsjahr: string,
    verein: string,
    startkategorie: IKategorie | null,
    check: string,
  }

  const newFormdata: IFormData = {
    anrede: "",
    name: "",
    email: "",
    geburtsjahr: "",
    verein: "",
    startkategorie: null,
    check: "",
  }

  type IAnswer = {
    "erfolg": string,
    "error": string
  }

  const [formData, setFormData] = useState<IFormData>();
  const [formError, setFormError] = useState<IFormError>();
  const [antwort, setAntwort] = useState<IAnswer>();
  const [kategorien, setKategorien] = useState<IKategorie[]>([]);
  const [ereignis, setEreignis] = useState<IEreignis[]>([]);

  const getData = async () => {

    await fetch('https://volkslauf-neermoor.de/rest/restGetAktuelleAnmeldungen.rest')
      .then(response => response.json())
      .then(setEreignis)
      .catch((e) => console.log(e));


    if (ereignis.length !== 0) {
      fetch('https://volkslauf-neermoor.de/rest/restGetKategorienAktuell.rest')
        .then(response => response.json())
        .then(setKategorien)
        .catch((e) => console.log(e));
    }

  }

  const whereError = () => {
    alert("Kein Erfolg! ");

    var error: IFormError = {
      anrede: '',
      name: '',
      email: '',
      geburtsjahr: '',
      verein: '',
      startkategorie: '',
      check: ''
    };

    if (antwort?.error === "Anrede ist fehlerhaft!") {
      error.anrede = antwort?.error;
    } else {
      alert("unbekannter fehler! " + antwort?.error);
    }
    setFormError(error);
  }

  const sendData = (e: FormEvent<HTMLFormElement>) => {

    e.preventDefault();
    const dataParam = new URLSearchParams();
    dataParam.append("inputAnrede", "" + formData?.anrede);
    dataParam.append("inputName", "" + formData?.name);
    dataParam.append("inputEmail", "" + formData?.email);
    dataParam.append("inputGeburtsjahr", "" + formData?.geburtsjahr);

    fetch("https://volkslauf-neermoor.de/rest/restAnmeldung.rest"
      , {
        method: "post"
        , headers: {
          'Accept': 'application/json',
          //'Content-Type': 'application/json'
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: dataParam
      }
    ).then(resp => resp.json())
      .then(setAntwort)
      .then(() => {
        if (antwort?.erfolg === "true") {
          alert("Erfolg");
          setFormData(newFormdata);
        } else {
          whereError();
        }
      })
      .catch(error => alert(error));
  }

  const getNewUid = () => {
    return uuidv4();
  }

  useEffect(() => {
    getData();
  }, []);


  return (
    <>

      {/*<MyHeader />*/}

      <div className="container">

        <div className="content row" >

          <MenuComponent aktuelleseite="anmeldung" />
          
          <div className="col-md-12 ml-sm-auto col-lg-12 px-4" role="main">

            {ereignis.length === 0 &&
              <div>Es sind zur Zeit keine Veranstaltungen zur Anmeldung verfügbar.</div>
            }

            {ereignis.length !== 0 &&
              <div>

                <h2 style={{ "textAlign": "center", "width": "100%" }}>Anmeldung zur Veranstaltung {ereignis[0].name}</h2>

                <div>
                  <table className="table">
                    <caption style={{ "captionSide": "top" }}>Einteilung der Jahrgänge in die U-Kategorien</caption>
                    <thead>
                      <th>Jahrgänge</th>
                      <th>Kategorie</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>2020 - 2021</td>
                        <td>U6</td>
                      </tr>
                      <tr>
                        <td>2018 - 2019</td>
                        <td>U8</td>
                      </tr>
                      <tr>
                        <td>2016 - 2017</td>
                        <td>U10</td>
                      </tr>
                      <tr>
                        <td>2014 - 2015</td>
                        <td>U12</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <form method="post" onSubmit={sendData}>
                  <input type="hidden" name="action" value="submit" />
                  <input type="hidden" name="formId" value={getNewUid()} />

                  <div className="form-group">
                    <label htmlFor="inputName">Ereignis:</label>
                    <input type="text" className="form-control" readOnly={true} value={ereignis?.at(0)?.name} />
                  </div>

                  <div className="form-group">
                    <label htmlFor="inputAnrede">Anrede:</label>
                    <select className={((formError?.anrede !== undefined && formError?.anrede !== "") ? "is-invalid" : "") + " form-control"} name="inputAnrede" id="inputAnrede" value={formData?.anrede}>
                      <option value="m" >Herr</option>
                      <option value="w" >Frau</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="inputName">Vor- und Nachname:</label>
                    <input type="text" className={((formError?.name !== undefined && formError?.name !== "") ? "is-invalid" : "") + " form-control"} name="inputName" id="inputName" value={formData?.name} />
                  </div>

                  <div className="form-group">
                    <label htmlFor="inputEmail">E-Mail Adresse:</label>
                    <input type="email" className={((formError?.email !== undefined && formError?.email !== "") ? "is-invalid" : "") + " form-control"} name="inputEmail" id="inputEmail" placeholder="z.B. max@example.com" value={formData?.email} />
                  </div>

                  <div className="form-group">
                    <label htmlFor="inputGeburtsjahr">Ihr Geburtsjahr</label>
                    <input type="text" className={((formError?.geburtsjahr !== undefined && formError?.geburtsjahr !== "") ? "is-invalid" : "") + "form-control"} name="inputGeburtsjahr" id="inputGeburtsjahr" placeholder="JJJJ" required={true} value={formData?.geburtsjahr} />
                  </div>

                  <div className="form-group">
                    <label htmlFor="inputVerein">Verein / Schule / Kindergarten</label>
                    <input type="text" className={((formError?.verein !== undefined && formError?.verein !== "") ? "is-invalid" : "") + " form-control"} name="inputVerein" id="inputVerein" value={formData?.verein} />
                  </div>

                  <div className="form-group">
                    <label htmlFor="inputKategorie">Startkategorie:</label>
                    <select className={((formError?.startkategorie !== undefined && formError?.startkategorie !== "") ? "is-invalid" : "") + " form-control"} name="inputKategorie" id="inputKategorie">
                      {
                        kategorien.map((e) =>
                          <>
                            <option value={e.id}>{e.name}</option>";
                          </>)
                      }
                    </select>
                  </div >

                  <input type="hidden" name="inputGruppe" value="keine" />

                  <p>
                    <br />
                    <b>Anmeldebedingungen:</b>
                    <br />
                    <br />Die eingegebenen Daten ( Anrede, Vor- und Nachnamen, Geburtsjahr und Vereinsnamen )
                    werden zur Veröffentlichung der Rangliste im Internet verwendet. Bei dieser Veranstaltung werden Bild und Tonaufnahmen
                    angefertigt. Mit der Teilnahme an dieser Veranstaltung stimmen Sie der Veröffentlichung dieser Aufnahmen zu.
                    Ihre E-Mailadresse wird für die Versendung von Informationen zu dieser Veranstaltung verwendet.
                  </p>

                  <div className="form-group">
                    <input className="form-check-input " type="checkbox" name="inputAgree" id="invalidCheck3" required={true} value={formData?.check} />
                    <label className="form-check-label" htmlFor="invalidCheck3">
                      Ich habe die Anmeldebedingungen gelesen und stimme diesen zu.
                    </label>

                  </div>

                  <div className="form-group">
                    <input type='submit' className="btn btn-primary" />
                  </div>

                </form >
              </div >
            }
          </div>
        </div>
      </div>

      <MyFooter />
    </>
  );
}

export default Anmeldung;